import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentStyles/Influencers.css';
import {
  mood1,
  mood2,
  mood3,
  mood4,
  mood5,
  smoking,
  enhancers_sleep,
  inhibitors_sleep,
  blockers_exercise,
  motivators_exercise,
  motivatorsHyd,
  blockersHyd,
  reasonAlc,
  reasonStress,
  inhibitorsProd,
  enhancersProd,
  boosters_energy,
  zappers_energy,
  notSmoking,
} from '../../shared/components/data';
import Warning from './Warning';

function Influencers(props) {
  const { t } = useTranslation();
  const [redList, setRedList] = useState({ title: '', list: [] });
  const [greenList, setGreenList] = useState({ title: '', list: [] });
  const [enhancerArr, setEnhancerArr] = useState([]);
  const [inhibitorArr, setInhibitorArr] = useState([]);
  const [showEnhancerError, setShowEnhancerError] = useState(false);
  const [showInhibitorError, setShowInhibitorError] = useState(false);
  const enhancerErrorRef = useRef(null);
  const inhibitorErrorRef = useRef(null);

  useEffect(() => {
    if (props.sleep) {
      setRedList({ title: t('T032'), list: [...inhibitors_sleep] });
      setGreenList({ title: t('T023'), list: [...enhancers_sleep] });
    } else if (props.activity) {
      setRedList({ title: t('T075'), list: [...blockers_exercise] });
      setGreenList({ title: t('T073'), list: [...motivators_exercise] });
    } else if (props.hydration) {
      setRedList({ title: t('T075'), list: [...blockersHyd] });
      setGreenList({ title: t('T073'), list: [...motivatorsHyd] });
    } else if (props.alcohol) {
      setRedList({ title: t(''), list: [...reasonAlc] });
      setGreenList({ title: t(''), list: [] });
    } else if (props.stress) {
      setRedList({ title: t(''), list: [...reasonStress] });
      setGreenList({ title: t(''), list: [] });
    } else if (props.mood) {
      if (props.moodValue === 0 || props.moodList <= 20) {
        setGreenList({ title: t(''), list: [...mood1] });
      } else if (props.moodValue <= 40) {
        setGreenList({ title: t(''), list: [...mood2] });
      } else if (props.moodValue <= 60) {
        setGreenList({ title: t(''), list: [...mood3] });
      } else if (props.moodValue <= 80) {
        setGreenList({ title: t(''), list: [...mood4] });
      } else {
        setGreenList({ title: t(''), list: [...mood5] });
      }

      setRedList({ title: t(''), list: [] });
    } else if (props.productivity) {
      setRedList({ title: t('T032'), list: [...inhibitorsProd] });
      setGreenList({ title: t('T023'), list: [...enhancersProd] });
    } else if (props.energy) {
      setRedList({ title: t('T032'), list: [...zappers_energy] });
      setGreenList({ title: t('T023'), list: [...boosters_energy] });
    } else if (props.notsmoking) {
      setRedList({ title: t('trackers.influencers.redList.title'), list: [] });
      setGreenList({ title: t('trackers.influencers.greenList.title'), list: [...notSmoking] });
    } else if (props.smoking) {
      setRedList({ title: t('trackers.influencers.redList.title'), list: [...smoking] });
      setGreenList({ title: t('trackers.influencers.greenList.title'), list: [] });
    }
    if (props.data?.[props.questionid[0]])
      setEnhancerArr(() =>
        props.data[props.questionid[0]].map((el) => {
          return { id: el };
        })
      );

    if (props.data?.[props.questionid[1]])
      setInhibitorArr(() =>
        props.data[props.questionid[1]].map((el) => {
          return { id: el };
        })
      );
  }, [props, t]);

  useEffect(() => {
    if (props.moodValue && enhancerArr.length > 0) {
      const updatedArr = enhancerArr.filter((item1) =>
        greenList.list.some((item2) => item2.id === item1.id)
      );
      // Only prune when something was actually filtered out, otherwise setting
      // a new array identity every run would loop this effect forever.
      if (updatedArr.length !== enhancerArr.length) {
        setEnhancerArr(updatedArr);
        const dbValues = [];
        updatedArr.forEach((item) => dbValues.push(item.id));
        props.saveResponse('journal', {
          id: props.questionid[0],
          value: dbValues,
        });
      }
    }
  }, [enhancerArr, greenList.list, props]);

  useEffect(() => {
    if (showEnhancerError && enhancerErrorRef.current) {
      setTimeout(() => {
        enhancerErrorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        enhancerErrorRef.current.focus();
      }, 100);
    }
  }, [showEnhancerError]);

  useEffect(() => {
    if (showInhibitorError && inhibitorErrorRef.current) {
      setTimeout(() => {
        inhibitorErrorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        inhibitorErrorRef.current.focus();
      }, 100);
    }
  }, [showInhibitorError]);

  const handleChange = (event, item, questionid) => {
    const isChecked = event.target.checked;

    if (questionid === props.questionid[0]) {
      // Handle enhancers
      if (isChecked) {
        if (enhancerArr.length < 3 || props.mood) {
          setShowEnhancerError(false);

          const newArr = [...enhancerArr, item];
          setEnhancerArr(newArr);
          const dbValues = newArr.map((entry) => entry.id);
          props.saveResponse('journal', {
            id: props.questionid[0],
            value: dbValues,
          });
        } else {
          setShowEnhancerError(true);
        }
      } else {
        setShowEnhancerError(false);

        const newArr = enhancerArr.filter((e) => e.id !== item.id);
        setEnhancerArr(newArr);
        const dbValues = newArr.map((entry) => entry.id);
        props.saveResponse('journal', {
          id: props.questionid[0],
          value: dbValues,
        });
      }
    } else if (questionid === props.questionid[1]) {
      // Handle inhibitors
      if (isChecked) {
        if (inhibitorArr.length < 3) {
          setShowInhibitorError(false);

          const newArr = [...inhibitorArr, item];
          setInhibitorArr(newArr);
          const dbValues = newArr.map((entry) => entry.id);
          props.saveResponse('journal', {
            id: props.questionid[1],
            value: dbValues,
          });
        } else {
          setShowInhibitorError(true);
        }
      } else {
        setShowInhibitorError(false);

        const newArr = inhibitorArr.filter((e) => e.id !== item.id);
        setInhibitorArr(newArr);
        const dbValues = newArr.map((entry) => entry.id);
        props.saveResponse('journal', {
          id: props.questionid[1],
          value: dbValues,
        });
      }
    }
  };

  const isItemSelected = (item, arr) => {
    return arr.some((e) => e.id === item.id);
  };

  return (
    <div className="influencers-cont">
      {greenList.list?.length > 0 && props.questionid && (
        <fieldset
          className={`list no-padding pos influencers-list ${
            !redList.list?.length ? 'influencers-list-single' : ''
          }`}
        >
          {!props.mood ? (
            <legend
              className="sub title"
              aria-labelledby={`${props.titleId} influencers-group-title  influencers-group-subtitle`}
            >
              <div id="influencers-group-title">
                {' '}
                {greenList.title?.length > 0 ? greenList.title : ' '}
              </div>
              <p style={{ textTransform: 'lowercase' }} id="influencers-group-subtitle">
                ({t('T074')} 3)
              </p>{' '}
            </legend>
          ) : (
            <legend className="sr-only">{t('T205')}</legend>
          )}

          {showEnhancerError && (
            <div className="influencers-error" tabIndex="-1" ref={enhancerErrorRef}>
              <Warning message={t('trackers.influencers.warning')} />
            </div>
          )}

          <ul className="fs-mask" aria-label={props.greenListAriaLabel || undefined}>
            {greenList.list.map((enh, index) => {
              const isSelected = enhancerArr.length > 0 && isItemSelected(enh, enhancerArr);
              const checkboxId = `enhancer-${enh.id}-${index}`;

              return (
                <li key={`enhancer-${enh.id}`}>
                  <label
                    htmlFor={checkboxId}
                    id={`enhancer-label-${enh.id}`}
                    className={isSelected ? 'active influencer-label' : 'influencer-label'}
                  >
                    <input
                      type="checkbox"
                      id={checkboxId}
                      checked={isSelected}
                      onChange={(e) => handleChange(e, enh, props.questionid[0])}
                      className="visually-hidden"
                      aria-labelledby={`enhancer-label-${enh.id}`}
                    />
                    {t(enh.label)}
                  </label>
                </li>
              );
            })}
          </ul>
        </fieldset>
      )}
      {redList.list?.length > 0 && props.questionid && (
        <fieldset
          className={`list neg no-padding influencers-list ${
            !greenList.list?.length ? 'influencers-list-single' : ''
          }`}
        >
          <legend
            className="sub title"
            aria-labelledby={`${props.titleId} influencers-red-group-title  influencers-red-group-subtitle`}
          >
            <div id="influencers-red-group-title">
              {redList.title?.length > 0 ? redList.title : ' '}
            </div>
            <p style={{ textTransform: 'lowercase' }} id="influencers-red-group-subtitle">
              ({t('T074')} 3)
            </p>{' '}
          </legend>

          {showInhibitorError && (
            <div className="influencers-error" tabIndex="-1" ref={inhibitorErrorRef}>
              <Warning message={t('trackers.influencers.warning')} />
            </div>
          )}

          <ul className="fs-mask" aria-label={props.redListAriaLabel || t('T074')}>
            {redList.list.map((inh, index) => {
              const isSelected = inhibitorArr.length > 0 && isItemSelected(inh, inhibitorArr);
              const checkboxId = `inhibitor-${inh.id}-${index}`;
              const alcoholClass = props.alcohol ? 'alc ' : '';

              return (
                <li key={`inhibitor-${inh.id}`}>
                  <label
                    htmlFor={checkboxId}
                    id={`inhibitor-label-${inh.id}`}
                    className={
                      isSelected
                        ? `${alcoholClass}active influencer-label`
                        : `${alcoholClass}influencer-label`
                    }
                  >
                    <input
                      type="checkbox"
                      id={checkboxId}
                      checked={isSelected}
                      onChange={(e) => handleChange(e, inh, props.questionid[1])}
                      className="visually-hidden"
                      aria-labelledby={`inhibitor-label-${inh.id}`}
                    />
                    {t(inh.label)}
                  </label>
                </li>
              );
            })}
          </ul>
        </fieldset>
      )}
    </div>
  );
}

export default Influencers;
